import React from 'react'
import { App } from 'Features/App/App'
// @ts-ignore
import { createRoot } from 'react-dom/client'
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser'
import { msalConfig } from 'Features/Auth/auth'

export const msalInstance = new PublicClientApplication(msalConfig)

// Handle the redirect callbacks
const handleMsalRedirectPromise = async () => {
  try {
    // Add flag to track ongoing auth redirect
    sessionStorage.setItem('authRedirectInProgress', 'true')

    // Handle redirect promise
    const response = await msalInstance.handleRedirectPromise()

    // Clear the flag once redirect is handled
    if (response) {
      sessionStorage.removeItem('authRedirectInProgress')
    }

    return response
  } catch (error) {
    console.error('Error during redirect handling:', error)
    sessionStorage.removeItem('authRedirectInProgress')
    return null
  }
}

msalInstance.initialize().then(() => {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult
      const account = payload.account
      msalInstance.setActiveAccount(account)
      console.log('Login Success:', account)

      // Clear auth redirect flag on successful login
      sessionStorage.removeItem('authRedirectInProgress')
    }
  })

  // Call the redirect handler before rendering the app
  handleMsalRedirectPromise().then(() => {
    const domNode = document.getElementById('root') as HTMLElement
    const root = createRoot(domNode)
    root.render(<App />)
  })
})
